<template>
    <span v-if="!hasRand" :name="k" class="text-view" v-html="t(k)"></span>
    <span v-else :name="k" class="text-view" >
        <count-to :startVal="val" :endVal="newVal" :suffix="suffix" :duration="300"/>
    </span>
</template>

<script>
    export default {
        name: "TextView",
        props: {
            k: String,
            max: String,
            min: String,
            time: String,
            suffix: String,
        },
        data() {
            return {
                val: 0,
                newVal: 0,
                timer: null,
                _min: 0,
                _max: 0,
                hasRand: false,
            }
        },
        created() {
            if(this.max) {
                this._min = Number(this.min || 0);
                this._max = Number(this.max || 0);
                clearInterval(this.timer);
                this.timer = setInterval(this.randVal, Number(this.time) || 3001);
            }
            this.val = Number(this.t(this.k));
        },
        methods: {
            randVal() {
                this.hasRand = true;
                let num = this.$t.randomNum(this._min, this._max);
                let old = parseInt(this.t(this.k));
                if(Date.now() % 2 == 0) {
                    num = old + num;
                } else {
                    num = old - num;
                }
                this.val = this.newVal;
                this.newVal = Math.abs(num);
            }
        }
    }
</script>

<style>
    .text-view {
        display: inline-block;
    }
</style>
